import { alpha, Theme } from '@mui/material/styles';

export const claimWeb3InteractionStyles = (theme: Theme, isDark: boolean) => ({
  container: {
    m: 2,
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    minHeight: '100vh',
    height: 'auto',
    backgroundColor: theme.palette.background.default,
    background: isDark
      ? `radial-gradient(circle at 25% 20%, ${alpha(
          theme.palette.primary.main,
          0.4
        )} 2%, ${
          theme.palette.background.default
        } 28%, transparent),radial-gradient(circle at 65% 75%, ${alpha(
          theme.palette.primary.main,
          0.4
        )} 1%, ${theme.palette.background.default} 35%) `
      : `radial-gradient(circle at 10% 12%, ${alpha(
          theme.palette.primary.main,
          0.22
        )} 2%, ${
          theme.palette.background.default
        } 28%, transparent),radial-gradient(circle at 70% 80%, ${alpha(
          theme.palette.primary.main,
          0.5
        )} 2%, ${theme.palette.background.default} 40%) `,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      mt: 1,
      mx: 0
    }
  },
  paperContainer: {
    px: 12,
    py: 3,
    height: 'fit-content',
    background: isDark
      ? 'linear-gradient(rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.07))'
      : 'rgba(233, 240, 253, 0.5)',
    boxShadow: isDark
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : 'rgb(0 0 0 / 7%) 0px 8px 13px 2px',
    backdropFilter: isDark ? 'blur(40px)' : 'blur(4px)',
    [theme.breakpoints.down('sm')]: {
      px: 5,
      mx: 1.5
    },
    borderRadius: '10px'
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    py: 4,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  stepContainer: {
    width: '100%',
    px: 3,
    mt: 3,
    mb: 1,
    [theme.breakpoints.down('sm')]: {
      pr: 3,
      mt: 2
    },
    height: '132px',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    overflow: 'hidden'
  },
  step: {
    display: 'flex',
    alignItems: 'center'
  },
  stepIcon: {
    mr: 2
  },
  loader: {
    minWidth: 260,
    ml: 3,
    [theme.breakpoints.down('md')]: {
      minWidth: 100
    }
  },
  contract: {
    ml: 2,
    wordWrap: 'break-word',
    maxWidth: '400px'
  },
  title: { pb: 1 },
  summary: {
    pb: 1
  },
  errorItem: { mt: 1 },
  giphy: { fontSize: '11px', mt: 0.5 },
  description: { pb: 1 },
  errorIcon: {
    '& svg': {
      width: 18,
      height: 18
    },
    mr: 1
  },
  containerIconAndError: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    my: 1.5
  },
  errorMessage: {
    pb: 0.5,
    [theme.breakpoints.up('md')]: {
      pl: 1.5
    }
  },
  linkSupport: {
    textDecoration: 'none',
    fontVariationSettings: "'wght' 500",
    '&:hover': {
      fontVariationSettings: "'wght' 500",
      textDecoration: 'underline'
    }
  }
});
